import FollowerDetails from './FollowerDetails';
import Import from './import';

const followers = {
  title: 'Abonnés',
  fields: {
    name: 'Nom',
    subscribed: 'Abonné',
    followed: 'Suivi',
    phone: 'Téléphone',
    recent_order: 'Commande récente',
    total_orders: 'Commandes totales',
    birthday: 'Anniversaire',
    google_review: 'Avis Google',
    marketing_subscription_source: 'Abonné depuis',
    loyalty_points: 'Fidélité',
  },
  empty_list: "Aucun client pour l'instant",
  yes: 'Oui',
  no: 'Non',
  buttons: {
    import: 'Importer',
    export: 'Exporter',
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
  },
  labels: {
    followed_since_date: 'Depuis le {{date}}',
  },
};

export default {
  ...followers,
  FollowerDetails,
  Import,
};
